import React from 'react'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import { useTranslation } from 'react-i18next'
import { SITE_ID } from '../../../../../constants'
import { EmptyContainer, EmptyImg, EmptySubtitle, EmptyTitle } from './mixins'
import emptyImgMobile from '../../../../../assets/images/ecommerce/carrito-vacio-mobile.svg'
import emptyImg from '../../../../../assets/images/ecommerce/carrito-vacio.svg'
import emptyImgZona from '../../../../../assets/images/ecommerce/carrito-vacio-zona.svg'
import emptyImgZonaMobile from '../../../../../assets/images/ecommerce/carrito-vacio-zona-mobile.svg'

const Component = () => {
  const { isMobile } = useScreenSize()
  const { t } = useTranslation()

  const selectImgMobile = (site: string) => {
    return site === 'ZJAR' ? emptyImgZonaMobile : emptyImgMobile
  }

  const selectImg = (site: string) => {
    return site === 'ZJAR' ? emptyImgZona : emptyImg
  }

  return (
    <EmptyContainer>
      <EmptyTitle>{t('ecommerce.emptyState.title')}</EmptyTitle>
      <EmptySubtitle>{t('ecommerce.emptyState.subtitle')}</EmptySubtitle>
      <EmptyImg src={isMobile ? selectImgMobile(SITE_ID) : selectImg(SITE_ID)} />
    </EmptyContainer>
  )
}
export default Component
